import { createAsyncThunk } from '@reduxjs/toolkit'
import { getTreatmentBenefitsPage, TreatmentBenefitsPageParams } from '../../../services/memberBenefits'
import { RootThunkApi } from '../../../app/store'
import { sendAsync } from '../../../app/applicationSlice'


export const getAddTreatmentPageAsync = createAsyncThunk<
  void,
  TreatmentBenefitsPageParams,
  RootThunkApi
>('addTreatment/getPage', async (params, api) => {
  return sendAsync(getTreatmentBenefitsPage(params), api)
})
